<footer id="footer">
  <div class="footer-newsletter">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <h4>Join Our Newsletter</h4>
          <p>Stay Connected for Exclusive Updates!</p>
          <form role="form" class="php-email-form" (submit)="subscribe($event)">
            <input type="email" name="email" aria-label="Email address"><input type="submit" value="Subscribe">
          </form>
          <p class="angular-form-message" *ngIf="newsletterMessage">{{ newsletterMessage }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 footer-contact">
          <h3>
            <a routerLink="/" class="logo me-auto">
              <img src="assets/img/anikinitechlogofooter.jpeg" alt="Anikinitek" class="img-fluid">
            </a>
          </h3>
          <p>
            <strong>Phone:</strong><a href="tel:+919494951828" style="color: black;"> +91 949 495 1828</a><br>
            <strong>Email:</strong><a href="mailto:info@anikinitek.com" style="color: black;"> info@anikinitek.com</a><br>
          </p>
        </div>

        <div class="col-lg-3 col-md-6 footer-links">
          <h4>Useful Links</h4>
          <ul>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/">Home</a></li>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/" fragment="about">About us</a></li>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/" fragment="services">Services</a></li>
          </ul>
        </div>

        <div class="col-lg-3 col-md-6 footer-links">
          <h4>Our Products</h4>
          <ul>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/asset-management" fragment="inventory">Asset Management System</a></li>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/ecommerce">E-Commerce Platform</a></li>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/career-platform">Career Connect Platform</a></li>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/property-platform">Property Platform</a></li>
          </ul>
        </div>

        <div class="col-lg-3 col-md-6 footer-links">
          <h4><i class="bx bx-chevron-right"></i> <a routerLink="/terms-of-service">Terms of service</a></h4>
          <h4><i class="bx bx-chevron-right"></i> <a routerLink="/privacy-policy">Privacy policy</a></h4>
        </div>
      </div>
    </div>
  </div>

  <div class="container footer-bottom clearfix">
    <div class="copyright">
      &copy; Copyright <strong><span>Anikini Technologies</span></strong>. All Rights Reserved
    </div>
  </div>
</footer>
